var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"position-fixed fixed-top m-0 rounded-0",staticStyle:{"z-index":"10000"},attrs:{"show":!_vm.$helpers.isBlank(_vm.message),"showTop":"","variant":_vm.message.type,"dismissible":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }